import { Routes, Route } from "react-router-dom";
import AgeRangesList from "./AgeRangesList";

export default function AgeRangesPage() {
    return (
        <Routes>
            <Route path="/" element={<AgeRangesList />}/>
        </Routes>
    )
}